import type { PendingApproval } from "./use-approvals";

/**
 * 判定し終えた次に開く承認を選ぶ（連続承認）。
 *
 * 一覧の並び（古い順）をそのまま進む。判定した案件が最後だった場合は先頭に
 * 戻らず終了する。戻すと同じ案件を二周して「終わったのか分からない」状態になる。
 *
 * 判定後は再取得で当該案件が一覧から消えるため、消えている場合は残りの先頭から
 * 続ける。
 */
export function selectNextApproval(
  items: readonly PendingApproval[],
  decidedTaskGuid: string,
): PendingApproval | null {
  const decidedIndex = items.findIndex(
    (item) => item.taskGuid === decidedTaskGuid,
  );

  if (decidedIndex === -1) {
    // 既に一覧から消えている＝残りの先頭が次
    return items[0] ?? null;
  }

  return items[decidedIndex + 1] ?? null;
}
